<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        Cash Advance Request Form
        <div class="card-header-actions">
          <button v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
          <button class="btn btn-danger mr-1" @click="close()"><i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row>
        <b-col lg="8">
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Request Number</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.nomor" v-b-tooltip.hover title="EMPTY for AUTO NUMBERING"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Request Date</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.tglRequ" type="date" :state="!$v.model.tglRequ.$error"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Request By</label>
                </b-input-group-prepend>
                <b-form-input readonly v-model="model.crewinfo" :state="!$v.model.crewkey.$error"></b-form-input>
                <b-input-group-append>
                  <b-btn text="Button" @click="lkuCrewShow = true">
                    <i class="fa fa-search"></i>
                  </b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Internal Budget No.</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.budgetnumber" readonly :state="!$v.model.ibudghdkey.$error"></b-form-input>
                <b-input-group-append v-if="!model.advanKey">
                  <b-btn text="Button" @click="lkuBudgetShow = true">
                    <i class="fa fa-search"></i>
                  </b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-col>
          </b-row>
          <b-input-group>
            <b-input-group-prepend>
              <label>Description</label>
            </b-input-group-prepend>
            <b-form-input v-model="model.keterangan" :state="!$v.model.keterangan.$error"></b-form-input>
            <b-input-group-append>
              <span class="input-group-text">{{ model.nomorproduksi }}</span>
            </b-input-group-append>
          </b-input-group>
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Request Amount</label>
                </b-input-group-prepend>
                <b-input-group-prepend>
                  <b-form-select class="input-group-text" v-model="model.matauang" :plain="true" :options="currency" :state="!$v.model.matauang.$error"></b-form-select>
                </b-input-group-prepend>
                <my-number class="form-control text-right" separator="," v-model="model.jumlah" :precision="2" :state="!$v.model.jumlah.$error"></my-number>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Paid To</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.dibayarke" :state="!$v.model.dibayarke.$error"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Event Date</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.tglEvent" type="date" :state="!$v.model.tglEvent.$error"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Settlement Due</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.tglKembali" type="date"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col lg="4">
          <b-input-group>
            <b-input-group-prepend>
              <label>Cash Flow</label>
            </b-input-group-prepend>
            <b-form-input readonly v-model="model.cashflow" @keyup.13.native="showLkuCashflow('model')" :state="!$v.model.kodecash.$error"></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" @click="showLkuCashflow('model')" id="apKodecash">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
          </b-input-group>
          <v-dim :model="model" :key="updateDimHdr"></v-dim>
        </b-col>
      </b-row>
      <!-- <b-card no-body class="mb-1" v-if="(model.ibudghdkey)">
        <b-table
          class="mb-0"
          ref="tblBudgetLines"
          outlined
          striped
          hover
          small
          style="font-size:smaller;"
          :items="budgetLines.items"
          :fields="budgetLines.fields"
          :current-page="budgetLines.page"
          :per-page="budgetLines.limit"
        >
          <template v-slot:cell(terpilih)="data">
            <b-form-checkbox
              v-model="data.item.terpilih"
              style="width:20px;"
              @change="checkedTogle(data.item)"
              value=1 unchecked-value=0 
              :disabled="!(data.item.ibbudgetamt)"
            ></b-form-checkbox>
          </template>

          <template v-slot:cell(index)="data">{{data.index + 1}}</template>
          <template
            v-slot:cell(requstart)="data"
          >{{ data.item.requstart | moment("DDMMMYYYY") }} - {{ data.item.requend | moment("DDMMMYYYY") }}</template>
          <template v-slot:cell(quantity)="data">
            {{data.item.quantity}} {{data.item.unitsize}}
            <span
              v-if="(data.item.repetit_qty)"
            >({{data.item.repetit_qty}} | {{data.item.repetit_nm}})</span>
          </template>
          <template v-slot:cell(ibbudgetamt)="data">
            <span style="margin-top: 2px !important;">{{data.item.ibbudgetamt | numFormat}} </span>
          </template>
           <template v-slot:cell(nilai)="data">
                <my-number v-if="(data.item.terpilih=='1')" v-model="data.item.nilai" @change="checkBudgetamt(data.item)" class="form-control text-right" style="border:none;margin-top: -5px !important; font-size: 0.75rem" :precision="2"></my-number>
            </template>
        </b-table>
        <b-row>
          <b-col cols="5">
            <b-row>
              <div class="ml-4">
                Showing {{((budgetLines.page - 1) * budgetLines.limit + 1)}}
                to
                <span
                  v-if="((budgetLines.page * budgetLines.limit)>budgetLines.total)"
                >{{budgetLines.total}}</span>
                <span v-else>{{budgetLines.page * budgetLines.limit}}</span>
                <strong>&nbsp; of {{budgetLines.total}} entries</strong>
              </div>
            </b-row>
          </b-col>
          <b-col cols="2">
            <b-input-group>
              <b-input-group-prepend>
                <span class="ml-4 pt-1 mr-2">Limit per page</span>
              </b-input-group-prepend>
              <b-form-select
                :options="[5, 10, 15, 20, 25, 30, 35, 40, 45, 50]"
                :plain="true"
                v-model="budgetLines.limit"
                style="width:80px;"
              />
            </b-input-group>
          </b-col>
          <b-col cols="5">
            <b-pagination
              align="right"
              :total-rows="budgetLines.total"
              :per-page="budgetLines.limit"
              v-model="budgetLines.page"
            ></b-pagination>
          </b-col>
        </b-row>
      </b-card> -->
      <b-card no-body class="mb-1">
        <b-table
          class="mb-0"
          ref="tblAdvLines"
          outlined
          striped
          hover
          small
          style="font-size: smaller"
          :items="advLines.items"
          :fields="advLines.fields"
          :current-page="advLines.page"
          :per-page="advLines.limit"
        >
          <template v-slot:cell(index)="data">{{ data.index + 1 }}</template>
          <template v-slot:cell(nilai)="data">{{ data.item.nilai | numFormat("0,0.00") }}</template>
          <template v-slot:cell(fixExpen)="data">
            <span v-if="data.item.fixExpen == 1">No Settlement</span>
          </template>
          <template v-slot:cell(duedate)="data">
            <span v-if="data.item.duedate">{{ data.item.duedate | moment("DD MMM YYYY") }}</span>
          </template>
          <template v-slot:cell(action)="data">
            <div class="text-center">
              <a href="javascript:void(0)" @click="editAdvLines(data.item, data.index, data.toggleDetails)">
                <i class="fa fa-pencil"></i>
              </a>
              |
              <a href="javascript:void(0)" class="text-danger" @click="delAdvLines(data.index)">
                <i class="fa fa-trash"></i>
              </a>
            </div>
          </template>
          <template v-slot:row-details="row">
            <b-card class="row-details-form">
              <b-row>
                <b-col lg="8">
                  <b-input-group v-if="model.ibudghdkey">
                    <b-input-group-prepend><label>Intern.Budget Line</label></b-input-group-prepend>
                    <b-form-input v-model="advLinesObj.budgetline" :state="!$v.advLinesObj.ibudgdtkey.$error" readonly></b-form-input>
                    <b-input-group-append>
                      <b-btn text="Button" @click="lkuBudgetInternShow = true">
                        <i class="fa fa-search"></i>
                      </b-btn>
                    </b-input-group-append>
                    <!-- <b-form-checkbox v-model="advLinesObj.ibudgdtkeyflag" value="YES" unchecked-value="NO"  class="ml-2 pt-2">NOT RELATED</b-form-checkbox> -->
                  </b-input-group>
                  <b-input-group>
                    <b-input-group-prepend>
                      <label>Description</label>
                    </b-input-group-prepend>
                    <b-form-input v-model="advLinesObj.uraian" :state="!$v.advLinesObj.uraian.$error"></b-form-input>
                  </b-input-group>
                  <b-row>
                    <b-col lg="6">
                      <b-input-group>
                        <b-input-group-prepend>
                          <label>Amount</label>
                        </b-input-group-prepend>
                        <b-input-group-prepend>
                          <span class="input-group-text" style="width: 70px">{{ model.matauang }}</span>
                        </b-input-group-prepend>
                        <my-number class="form-control text-right" v-model="advLinesObj.nilai" :precision="2" :state="!$v.advLinesObj.nilai.$error"></my-number>
                      </b-input-group>
                    </b-col>
                    <b-col lg="5">
                      <b-input-group>
                        <b-input-group-prepend>
                          <label>Payment Due/Schedule</label>
                        </b-input-group-prepend>
                        <b-form-input v-model="advLinesObj.duedate" type="date" :state="!$v.advLinesObj.duedate.$error"></b-form-input>
                      </b-input-group>
                    </b-col>
                  </b-row>
                  <b-input-group>
                    <b-input-group-prepend>
                      <label>Fix Amount Expenses</label>
                    </b-input-group-prepend>
                    <b-form-radio-group v-model="advLinesObj.fixExpen" name="radioIndividu" class="ml-1 mt-1" :state="!$v.advLinesObj.fixExpen.$error">
                      <b-form-radio :value="0">No (Do Settlement after Event)</b-form-radio>
                      <b-form-radio :value="1">Yes (No Settlement after Event)</b-form-radio>
                    </b-form-radio-group>
                  </b-input-group>
                  <b-input-group v-if="advLinesObj.fixExpen == 1">
                    <b-input-group-prepend>
                      <label>GL Account No.</label>
                    </b-input-group-prepend>
                    <b-form-input readonly v-model="advLinesObj.glAccount" @keyup.13.native="lkuCoaShow = true" :state="!$v.advLinesObj.kodeacc.$error"></b-form-input>
                    <b-input-group-append>
                      <b-btn text="Button" @click="lkuCoaShow = true" id="glAccount">
                        <i class="fa fa-search"></i>
                      </b-btn>
                    </b-input-group-append>
                  </b-input-group>
                </b-col>
                <b-col lg="4">
                  <b-input-group>
                    <b-input-group-prepend><label>Cash Flow</label></b-input-group-prepend>
                    <b-form-input readonly v-model="advLinesObj.cashflow" @keyup.13.native="showLkuCashflow('advLinesObj')"></b-form-input>
                    <b-input-group-append>
                      <b-btn text="Button" @click="showLkuCashflow('advLinesObj')">
                        <i class="fa fa-search"></i>
                      </b-btn>
                    </b-input-group-append>
                  </b-input-group>
                  <v-dim :model="advLinesObj" :key="updateDimDtl"></v-dim>
                </b-col>
              </b-row>
              <b-row class="justify-content-center mt-1">
                <div style="width: 400px">
                  <b-input-group>
                    <b-input-group-prepend><span class="p-2">Add Line after update</span></b-input-group-prepend>
                    <b-form-checkbox v-model="inputLineBerlanjut" :value="1" :unchecked-value="0" class="pt-2"></b-form-checkbox>
                    <b-input-group-append>
                      <b-button class="btn btn-success mr-1" @click="saveAdvLines()">Update</b-button>
                    </b-input-group-append>
                    <b-input-group-append>
                      <b-button class="btn btn-warning ml-1" @click="row.toggleDetails">Cancel</b-button>
                    </b-input-group-append>
                  </b-input-group>
                </div>
              </b-row>
            </b-card>
          </template>
        </b-table>
        <b-row>
          <b-col cols="5">
            <b-row>
              <b-button size="sm" class="ml-3" @click="addAdvLines">Add Advance Detail</b-button>
              <div class="ml-2">
                Showing {{ (advLines.page - 1) * advLines.limit + 1 }}
                to
                <span v-if="advLines.page * advLines.limit > advLines.total">{{ advLines.total }}</span>
                <span v-else>{{ advLines.page * advLines.limit }}</span>
                <strong>&nbsp; of {{ advLines.total }} entries</strong>
              </div>
            </b-row>
          </b-col>
          <b-col cols="2">
            <b-input-group>
              <b-input-group-prepend>
                <span class="ml-4 pt-1 mr-2">Limit per page</span>
              </b-input-group-prepend>
              <b-form-select :options="[5, 10, 15, 20, 25, 30, 35, 40, 45, 50]" :plain="true" v-model="advLines.limit" style="width: 80px" />
            </b-input-group>
          </b-col>
          <b-col cols="5">
            <b-pagination align="right" :total-rows="advLines.total" :per-page="advLines.limit" v-model="advLines.page"></b-pagination>
          </b-col>
        </b-row>
      </b-card>
      <b-row align-h="between" class="mt-1">
        <b-col lg="8" xl="7">
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Advance Group</label>
                </b-input-group-prepend>
                <b-form-select v-model="model.jenisAdv" :plain="true" :options="postGroups" :state="!$v.model.jenisAdv.$error"></b-form-select>
              </b-input-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col lg="4">
          <div class="text-right">
            <b-input-group>
              <b-input-group-prepend>
                <label style="text-align: left; width: 180px !important; padding-right: 5px">subtotal Advance Detail</label>
              </b-input-group-prepend>
              <b-input-group-prepend>
                <span class="input-group-text" style="width: 70px">{{ model.matauang }}</span>
              </b-input-group-prepend>
              <my-number class="form-control text-right" v-model="model.ttlnetto" :precision="2" disabled></my-number>
            </b-input-group>
          </div>
        </b-col>
      </b-row>
      <b-row class="justify-content-center mb-2">
        <div style="width: 450px">
          <b-input-group>
            <b-input-group-prepend><span class="p-2">remain on Form after save</span></b-input-group-prepend>
            <b-form-checkbox v-model="inputBerlanjut" :value="1" :unchecked-value="0" class="pt-2"></b-form-checkbox>
            <b-input-group-append>
              <button v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
            </b-input-group-append>
            <b-input-group-append>
              <button class="btn btn-danger mr-1" @click="close()"><i class="fa fa-close"></i> Close</button>
            </b-input-group-append>
          </b-input-group>
        </div>
      </b-row>
    </b-card>
    <b-modal v-model="lkuCrewShow" size="lg" :hide-footer="true" title="List of Employee" :centered="true">
      <lku-crew @click="onSelectLkuCrew" :formdata="lkuCrewData"></lku-crew>
    </b-modal>
    <b-modal v-model="lkuCashflowShow" size="lg" :hide-footer="true" title="List of Cashflow Account" :centered="true">
      <lku-cashflow @click="onSelectLkuCashflow" :formdata="lkuCashflowData" typeacc="OUT"></lku-cashflow>
    </b-modal>
    <b-modal v-model="lkuCoaShow" size="lg" :hide-footer="true" title="List of GL Account" :centered="true">
      <lku-coa @click="onSelectLkuCoa" :tahun="tahun" :key="tahun"></lku-coa>
    </b-modal>
    <b-modal v-model="lkuBudgetShow" size="lg" :hide-footer="true" title="List of Internal Budget" :centered="true">
      <lku-budgetinternal @click="onSelectLkuBudget"></lku-budgetinternal>
    </b-modal>
    <b-modal v-model="lkuBudgetInternShow" size="lg" :hide-footer="true" title="Internal Budget Items" :centered="true">
      <lku-budgetinternalline @click="onSelectLkuBudgetIntern" :ibudghdkey="model.ibudghdkey" :formdata="lkuBudgetInternData" :key="model.ibudghdkey"></lku-budgetinternalline>
    </b-modal>
  </div>
</template>
<style lang="scss">
.input-group {
  padding-bottom: 2px;
  .input-group-prepend {
    label {
      padding-top: 5px;
      padding-right: 5px;
      width: 130px;
    }
  }
}
.form-group {
  margin-bottom: 2px;
  .input-group {
    padding-bottom: 0;
  }
}
.row-details-form {
  label {
    text-align: right !important;
  }
  legend {
    text-align: right !important;
  }
}
</style>

<script>
import toastr from "mini-toastr";
import moment from "moment";
import myNumber from "../../components/my-number";
import vDim from "../lookup/dim";
import lkuBudgetinternal from "../lookup/lkuBudgetinternal";
import lkuBudgetinternalline from "../lookup/lkuBudgetinternallineLazzy.vue";
import lkuCrew from "../lookup/lkuCrewlazzy";
import lkuCashflow from "../lookup/lkuCashflowLazzy";
import lkuCoa from "../lookup/lkuCoa";
import advance from "../../apis/advance";
import dimension from "../../apis/dimension";
import { validationMixin } from "vuelidate";
import { required, requiredIf, minValue, maxLength, numeric } from "vuelidate/lib/validators";
toastr.init();

export default {
  components: {
    myNumber,
    vDim,
    lkuBudgetinternal,
    lkuBudgetinternalline,
    lkuCrew,
    lkuCashflow,
    lkuCoa,
  },
  mixins: [validationMixin],
  validations: {
    model: {
      crewkey: { required },
      keterangan: { required },
      tglRequ: { required },
      jenisAdv: { required },
      kodecash: { required },
      matauang: { required },
      dibayarke: { required },
      jumlah: { required, minValue: minValue(1) },
      tglEvent: { required },
      // ibudgdtkey: {
      //   required: function () {
      //     if ((this.budgeted || 0) == 0) {
      //       return true;
      //     } else if ((this.model.ibudgdtkey || "") == "") {
      //       return false;
      //     } else return true;
      //   },
      // },
      ibudghdkey: {
        required: function () {
          if ((this.budgeted || 0) == 0) {
            return true;
          } else if ((this.model.ibudghdkey || "") == "") {
            return false;
          } else return true;
        },
      },
      // pjxbudgkey: {
      //   required: function () {
      //     if ((this.budgeted || 0) == 0) {
      //       return true;
      //     } else if ((this.model.pjxbudgkey || "") == "") {
      //       return false;
      //     } else return true;
      //   },
      // },
      // pjxkey: {
      //   required: function () {
      //     if ((this.budgeted || 0) == 0) {
      //       return true;
      //     } else if ((this.model.pjxkey || "") == "") {
      //       return false;
      //     } else return true;
      //   },
      // },
    },
    advLinesObj: {
      ibudgdtkey: {
        required: function () {
          if (this.model.ibudghdkey) {
            if (this.advLinesObj.ibudgdtkey) {
              if (this.advLinesObj.ibudghdkey == "N/A") return true;
              else {
                if (this.model.ibudghdkey == this.advLinesObj.ibudghdkey) {
                  return true;
                } else {
                  toastr.error(`Budget Line not from Internal Budget`, "Line/Detail Expenses", 10000);
                  return false;
                }
              }
            } else return false;
          } else return true;
        },
      },
      kodeacc: {
        required: function () {
          if ((this.advLinesObj.fixExpen || 0) == 0) {
            return true;
          } else if ((this.advLinesObj.kodeacc || "") == "") {
            return false;
          } else return true;
        },
      },
      fixExpen: { required },
      uraian: { required },
      duedate: { required },
      nilai: { required },
    },
  },
  data() {
    return {
      inputBerlanjut: 1,
      inputLineBerlanjut: 1,
      saveEnabled: true,
      budgeted: 0,
      lkuBudgetShow: false,
      lkuBudgetInternShow: false,
      lkuBudgetInternData: {},
      budgetamt: 0,
      requestamt: 0,
      lkuCashflowData: {},
      lkuCashflowShow: false,
      lkuCashflowCaller: "model",
      lkuCrewData: {},
      lkuCrewShow: false,
      lkuPorderShow: false,
      updateDimHdr: false,
      updateDimDtl: true,
      tahun: (this.$store.state.user.tglaktif || "").substring(0, 4),
      uanguser: this.$store.state.user.matauang,
      postGroups: [],
      currency: [{ value: "IDR", text: "IDR" }],
      YesNo: [
        { value: 1, text: "YES" },
        { value: 0, text: "NO" },
      ],
      advLines: {
        items: [],
        selected: {},
        fields: [
          { key: "index", label: "No.", thStyle: "width:40px" },
          {
            key: "uraian",
            label: "Description",
          },
          {
            key: "glAccount",
            label: "GL Account",
          },
          {
            key: "nilai",
            label: "Amount",
            thStyle: "width:140px",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "fixExpen",
            label: "Fixed",
            thStyle: "width:100px",
            thClass: "text-center",
            tdClass: "text-center",
          },
          {
            key: "duedate",
            label: "Payment Schedule",
            thStyle: "width:140px",
            thClass: "text-center",
            tdClass: "text-center",
          },
          {
            key: "action",
            label: "Action",
            thStyle: "width:60px",
            thClass: "text-center",
          },
        ],
        page: 1,
        limit: 5,
        total: 0,
      },
      budgetLines: {
        items: [],
        selected: {},
        fields: [
          { key: "index", label: "No.", thStyle: "width:40px" },
          {
            key: "jccostname",
            label: "Item Nane",
            sortable: true,
          },
          {
            key: "uraian",
            label: "Budget Name",
          },
          {
            key: "noprodintern",
            label: "No. Produk/Eps.",
          },
          {
            key: "quantity",
            label: "quantity",
          },
          {
            key: "ibbudgetamt",
            label: "Budget Amount",
            thStyle: "width:110px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "terpilih",
            label: "",
            thStyle: "width:20px",
            thClass: "text-center",
            tdClass: "text-center",
          },
          {
            key: "nilai",
            label: "Advance Amount",
            thStyle: "width:110px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true,
          },
        ],
        page: 1,
        limit: 10,
        total: 0,
      },
      model: {
        crewkey: "",
        keterangan: "",
        tglRequ: "",
        jenisAdv: "",
        kodecash: "",
        matauang: this.$store.state.user.matauang,
        dibayarke: "",
        jumlah: 0,
        ibudgdtkey: "",
        ibudghdkey: "",
        ibudgdtkeyB4: "",
        pjxbudgkey: "",
        pjxkey: "",
        final: 1,
      },
      reqLines: {
        page: 1,
        limit: 5,
        total: 0,
      },
      advLinesObj: {
        kodeacc: "",
        glAccount: "",
        fixExpen: "",
        uraian: "",
        duedate: "",
        nilai: 0,
        pjxbudgkey: "",
        ibudghdkey: "",
        ibudgdtkey: "",
        ibbudgetamt: 0,
        kodecash: "",
        cashflow: "",
      },
      adminAdv: true,
      lkuCoaShow: false,
    };
  },
  computed: {
    dimension() {
      return this.$store.state.dimension;
    },
    invalidAdvLines() {
      this.$v.advLinesObj.$touch();
      return this.$v.advLinesObj.$invalid;
    },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
  },
  watch: {
    "model.jenisAdv": function (newval) {
      this.budgeted = (this.postGroups.find((d) => d.value === newval) || {}).budgeted || 0;
    },
  },
  created: async function () {
    const { user } = this.$store.state;
    if (this.$route.params.crewkey) {
      this.adminAdv = false;
      this.model.crewinfo = user.full_name + " | " + user.crewnik.trim();
      this.model.crewkey = user.crewkey;
      this.model.dibayarke = user.full_name.trim();
      this.model.final = 0;

      const dim = this.dimension.find((d) => d.RelatedObj == "department");
      if (dim) {
        this.model[`${dim.value}`] = user.departkd;
        this.model[`${dim.value}Txt`] = user.departemen;
        this.model[`${dim.value}Info`] = user.departkd + " | " + user.departemen;
      }
    }
    if (this.$route.params.advanKey) {
      toastr.info("Loading ADVANCE Detail, please wait");
      try {
        const [a, b, data] = await Promise.all([advance.advancegroup(), advance.currency(), advance.detail(this.$route.params)]);
        this.postGroups = a;
        this.currency = b;
        // const data = await advance.detail(this.$route.params);
        const row = data[0][0];
        row.tglRequ = row.tglRequ ? moment(row.tglRequ).format("YYYY-MM-DD") : "";
        row.tglEvent = row.tglEvent ? moment(row.tglEvent).format("YYYY-MM-DD") : "";
        row.tglKembali = row.tglKembali ? moment(row.invtglKembali).format("YYYY-MM-DD") : "";
        for (var key in row) {
          this.model[key] = row[key];
        }
        if (this.model.ibudgdtkey) this.model.ibudgdtkeyB4 = this.model.ibudgdtkey;
        this.model.tglBayar = this.model.tglBayar ? moment(this.model.tglBayar).format("YYYY-MM-DD") : "";

        if (this.model.send2wf == 1 && user.use_wfservice == 1) {
          this.saveEnabled = false;
        }

        this.advLines.items = data[1];
        this.advLines.total = this.advLines.items.length;
        if (this.model.ibudghdkey) {
          this.budgetLines.items = data[2];
          this.budgetLines.total = this.budgetLines.items.length;
        }
        this.calcDtlAdv();
        this.updateDimHdr = !this.updateDimHdr;

        // if (row.ibudgdtkey) {
        //   const lineProgress = await advance.budgetprogressdtlsmry({
        //     ibudgdtkey: row.ibudgdtkey,
        //   });
        //   if (lineProgress) {
        //     this.budgetbalance =
        //       lineProgress.ibbudgetamt -
        //       lineProgress.sottl -
        //       lineProgress.pottl -
        //       lineProgress.cattl -
        //       lineProgress.ecttl +
        //       row.jumlah;
        //   }
        // }
        toastr.clear;
      } catch (error) {
        console.log("error : ", error);
        toastr.error(JSON.stringify(error), "ERROR MESSAGE");
      }
    } else {
      const [a, b] = await Promise.all([advance.advancegroup(), advance.currency()]);
      this.postGroups = a;
      this.currency = b;
      this.model.tglRequ = moment().format("YYYY-MM-DD");
      // this.$forceUpdate();

      const dim = this.dimension.find((d) => d.RelatedObj == "department");
      if (dim) {
        this.model[`${dim.value}`] = this.$store.state.user.departkd;
        this.model[`${dim.value}Txt`] = this.$store.state.user.departemen;
        this.model[`${dim.value}Info`] = this.$store.state.user.departkd + " | " + this.$store.state.user.departemen;
      }
    }

    this.$watch('model.ibudghdkey', function(newval) {
        // setTimeout(() => {
            this.advLinesObj.ibudgdtkeyflag='YES'
            this.advLinesObj.ibudghdkey='N/A';
            this.advLinesObj.ibudgdtkey='N/A';
            this.advLinesObj.budgetline='';
            this.advLinesObj.items.forEach((line)=>{
                line.ibudgdtkey='';
                line.budgetline='';
                line.ibudgdtkeyflag='YES'
                line.budgetline='';
            });         
        // }, 200);
    });

  },
  methods: {
    showLkuCashflow(callerObj) {
      this.lkuCashflowShow = true;
      this.lkuCashflowCaller = callerObj;
    },
    onSelectLkuCashflow(lkuData) {
      this.lkuCashflowData = lkuData;
      this.lkuCashflowShow = false;
      this[this.lkuCashflowCaller].cashflow = lkuData.selected.kodecash.trim() + " | " + lkuData.selected.namacash.trim();
      this[this.lkuCashflowCaller].kodecash = lkuData.selected.kodecash;
      this[this.lkuCashflowCaller].namacash = lkuData.selected.namacash;
      if ((this.model.cashflow || "") == "") {
        this.model.cashflow = lkuData.selected.kodecash.trim() + " | " + lkuData.selected.namacash.trim();
        this.model.kodecash = lkuData.selected.kodecash;
        this.model.namacash = lkuData.selected.namacash;
      }
      this.lkuCashflowShow = false;
    },
    onSelectLkuCrew: async function (lkuData) {
      this.lkuCrewData = lkuData;
      this.lkuCrewShow = false;
      if (this.adminAdv) {
        this.model.crewinfo = lkuData.selected.crewname.trim() + " | " + lkuData.selected.crewnik.trim();
        this.model.crewkey = lkuData.selected.crewkey;
        this.model.dibayarke = this.model.dibayarke || lkuData.selected.crewname.trim();
        const dim = this.dimension.find((d) => d.RelatedObj == "department");
        if (dim) {
          this.model[`${dim.value}`] = lkuData.selected.departkd;
          this.model[`${dim.value}Txt`] = lkuData.selected.departemen;
          this.model[`${dim.value}Info`] = lkuData.selected.departkd + " | " + lkuData.selected.departemen;
        }
      }
      this.lkuCrewShow = false;
    },
    onSelectLkuCoa(_selected) {
      this.advLinesObj.glAccount = _selected.kodeacc.trim() + " | " + _selected.namaacc.trim();
      this.advLinesObj.kodeacc = _selected.kodeacc;
      this.advLinesObj.namaacc = _selected.namaacc;
      this.lkuCoaShow = false;
    },
    onSelectLkuBudget: async function (_selected) {
      try {
        toastr.info("Loading Budget Item/lines");
        // advance.budgetline(_selected).then((result) => {
        //   this.budgetLines.items = result[1];
        //   this.budgetLines.total = this.budgetLines.items.length;
        //   this.budgetLines.items.forEach(i => {
        //     i.terpilih=0,
        //     i.nilai= i.ibbudgetamt || 0;
        //   })
        // });
        this.model.keterangan = _selected.uraian;
        this.model.budgetnumber = _selected.nomorintern;
        this.model.nomorproduksi = _selected.noprodintern;
        this.model.ibudgdtkey = _selected.ibudgdtkey;
        this.model.ibudghdkey = _selected.ibudghdkey;
        this.model.pjxbudgkey = _selected.pjxbudgkey;
        this.model.pjxkey = _selected.pjxhdrkey;
        this.model.DimTableKey = _selected.DimTableKey;
        // this.budgetbalance = _selected.ibbudgetamt - _selected.requestamt;

        this.model.tglEvent = _selected.requstart ? moment(_selected.requstart).format("YYYY-MM-DD") : "";
        this.dimension.forEach((dim) => {
          if (_selected[dim.value]) {
            this.model[`${dim.value}`] = _selected[dim.value];
            this.model[`${dim.value}Txt`] = _selected[`${dim.value}Txt`];
            this.model[`${dim.value}Info`] = _selected[dim.value] + " | " + _selected[`${dim.value}Txt`];
          }
          if (dim.RelatedObj == "internalbudget") {
            this.model[`${dim.value}`] = _selected.nomorintern;
            this.model[`${dim.value}Txt`] = _selected.uraian + " # " + _selected.noprodintern;
            this.model[`${dim.value}Info`] = _selected.nomorintern + " | " + _selected.uraian + " # " + _selected.noprodintern;
          }
        });
        this.updateDimHdr = !this.updateDimHdr;
        this.lkuBudgetShow = false;
      } catch (error) {
        console.log("error : ", error);
        toastr.error(JSON.stringify(error), "ERROR MESSAGE");
      }
    },
    onSelectLkuBudgetIntern: async function (ibLineObj) {
      try {
        console.log("ibLineObj.selected", ibLineObj.selected);
        this.advLinesObj.jccostname = ibLineObj.selected.jccostname;
        this.advLinesObj.budgetline = `${ibLineObj.selected.jccostname} ${ibLineObj.selected.jccostnote || ibLineObj.selected.uraian}`;
        this.advLinesObj.ibudgdtkey = ibLineObj.selected.ibudgdtkey;
        this.advLinesObj.ibudghdkey = ibLineObj.selected.ibudghdkey;
        this.advLinesObj.ibbudgetamt = ibLineObj.selected.ibbudgetamt;
        this.advLinesObj.ibudgdtkeyflag = "NO";
        if (!this.advLinesObj.uraian) this.advLinesObj.uraian = this.advLinesObj.budgetline;
        if (ibLineObj.selected.itemname) {
          this.advLinesObj.itemno = ibLineObj.selected.itemno;
          this.advLinesObj.itemname = ibLineObj.selected.itemname;
          this.advLinesObj.iteminfo = ibLineObj.selected.partnumber.trim() + " | " + ibLineObj.selected.itemname.trim();
          this.advLinesObj.partnumber = ibLineObj.selected.partnumber;
          this.advLinesObj.invunitom = ibLineObj.selected.invunitom || ibLineObj.selected.unitsize;
        }

        this.lkuBudgetInternShow = false;
        this.lkuBudgetInternData = ibLineObj;
      } catch (error) {
        console.log("error : ", error);
        toastr.error(JSON.stringify(error), "ERROR MESSAGE");
      }
    },
    closeAdvLines: function () {
      const opened = this.advLines.items.find((r) => r._showDetails == true);
      if (opened) opened._showDetails = false;
    },
    addAdvLines: function () {
      this.closeAdvLines();
      const obj = {
        _showDetails: true,
        kodeacc: "",
        uraian: "",
        fixExpen: "0",
        DimTableKey: "",
        terpilih: 1,
      };
      this.advLines.selected = obj;
      (this.advLinesObj.advDtlKey = ""), (this.advLinesObj.fixExpen = 0);
      this.advLinesObj.nilai = 0;
      this.advLinesObj.uraian = "";
      this.advLinesObj.kodeacc = "";
      if (this.model.tglEvent) {
        this.advLinesObj.duedate = moment(this.model.tglEvent, "YYYY-MM-DD").format("YYYY-MM-DD");
      } else {
        this.advLinesObj.duedate = this.model.tglRequ ? moment(this.model.tglRequ, "YYYY-MM-DD").add(5, "d").format("YYYY-MM-DD") : moment().add(5, "d").format("YYYY-MM-DD");
      }
      this.advLinesObj.cashflow = this.model.cashflow;
      this.advLinesObj.kodecash = this.model.kodecash;
      this.advLinesObj.namacash = this.model.namacash;

      this.updateDimHdr2Dtl(this.advLinesObj);
      this.advLines.items.push(obj);
      this.advLines.total = this.advLines.items.length;
      setTimeout(() => {
        const bfore = this.reqLines.page;
        const after = Math.ceil(this.reqLines.total / this.reqLines.limit);
        if (bfore != after) {
          this.reqLines.page = after;
          toastr.info(`Move to page ${after} of total  ${this.reqLines.total} items`, "Line/Detail", 10000);
        }
      }, 100);

      this.inputLineBerlanjut = 1;
    },
    editAdvLines: function (obj, index, callback) {
      this.closeAdvLines();
      this.advLines.items[index].terpilih = 1;
      this.advLines.selected = obj;
      for (var key in this.advLinesObj) {
        this.advLinesObj[key] = "";
      }
      for (var key in obj) {
        this.advLinesObj[key] = obj[key];
      }
      this.dimension.forEach((dim) => {
        if (obj[dim.value]) {
          this.advLinesObj[dim.value] = obj[dim.value];
          this.advLinesObj[`${dim.value}Txt`] = obj[`${dim.value}Txt`];
          this.advLinesObj[`${dim.value}Info`] = obj[dim.value] + " | " + obj[`${dim.value}Txt`];
        }
      });
      if (obj.kodecash && !obj.cashflow) {
        this.advLinesObj.cashflow = obj.kodecash;
      }
      this.inputLineBerlanjut = 0;
      callback();
    },
    delAdvLines: function (index) {
      if (index > -1) {
        const posisi = (this.advLines.page - 1) * this.advLines.limit;
        this.advLines.items.splice(posisi + index, 1);
      }
      this.advLines.total = this.advLines.items.length;
      this.calcDtlAdv();
    },
    saveAdvLines: async function (callback) {
      if (this.invalidAdvLines) {
        console.log("validation : ", this.$v.advLinesObj);
        console.log("model obj : ", this.advLinesObj);
        if (this.$v.model.ibudghdkey.$error) {
          toastr.error("BUDGET required for this CASH-ADVANCE GROUP", "ERROR MESSAGE");
        } else {
          toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
        }
      } else {
        if ((this.model.ibudghdkey || "") != "") {
          this.checkBudgetamt(this.advLinesObj);
        }
        let datadim = this.advLinesObj;
        datadim.TableName = "advancedetail";
        try {
          const dimValResult = await dimension.validate(datadim);
          if (dimValResult.success) {
            this.advLinesObj.terpilih = 0;
            for (var key in this.advLinesObj) {
              this.advLines.selected[key] = this.advLinesObj[key];
            }
            this.dimension.forEach((dim) => {
              if (datadim[dim.value]) {
                this.advLines.selected[dim.value] = datadim[dim.value];
                this.advLines.selected[`${dim.value}Txt`] = datadim[`${dim.value}Txt`];
              }
            });
            this.advLines.total = this.advLines.items.length;
            this.updateDimDtl2Hdr(datadim);
            this.calcDtlAdv();
            this.advLines.selected._showDetails = false;
            if (callback) callback();
            if (this.inputLineBerlanjut == 1) {
              this.addAdvLines();
              this.$v.advLinesObj.$reset();
            }
          } else {
            console.log("dimValResult : ", dimValResult);
            var msg = dimValResult.message;
            if (callback) callback(new Error(msg));
            else {
              toastr.error(msg, "ERROR MESSAGE", 10000);
            }
          }
        } catch (error) {
          console.log("error : ", error);
          if (error.message) {
            toastr.error(error.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
        }
      }
    },
    save: async function () {
      if (!this.saveEnabled) {
        toastr.error("View mode cannot be Saved");
        return;
      }
      this.saveEnabled = false;
      if (this.invalidModel) {
        console.log("validation : ", this.$v.model);
        console.log("model obj : ", this.model);
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
        this.saveEnabled = true;
      } else if (Math.abs(this.model.jumlah - parseFloat(this.model.ttlnetto)) > 0.5 && this.model.ttlnetto) {
        toastr.error("[Total Request] not Balance with [SubTotal Detail Request]", "ERROR MESSAGE", 10000);
        this.saveEnabled = true;
      } else if (this.budgeted == 1 && this.budgetbalance < parseFloat(this.model.jumlah)) {
        toastr.error(`[Total Request] exceed from [Budget Balance] ${this.budgetbalance.toLocaleString(undefined, { maximumFractionDigits: 2 })}`, "ERROR MESSAGE", 10000);
        this.saveEnabled = true;
      } else {
        if (this.model.ibudghdkey) {
          const hasBudgetLineRefer = this.advLines.items.some(item => item.uraian && item.nilai && item.ibudgdtkey && item.ibudgdtkey !== 'N/A');
          if (!hasBudgetLineRefer) {
            toastr.error('Harus ada lines/detail Cash-Advance yang merefer ke budget line', "Error - Line/Detail Advance", 10000);
            this.saveEnabled = true;
            return;
          }
        }
        try {
          this.model.TableName = "advance";
          const dimValResult = await dimension.validate(this.model);
          if (dimValResult.success) {
            this.model.advanKey = this.model.advanKey || "";
            this.model.nomor = this.model.nomor || "";
            this.model.final = 0;
            const row = {};
            for (var key in this.model) {
              row[key] = this.model[key];
            }
            row.isProject = this.budgeted;
            row.tglRequ = moment(row.tglRequ).format("YYYY-MM-DD");
            row.tglEvent = row.tglEvent ? moment(row.tglEvent).format("YYYY-MM-DD") : undefined;
            row.tglKembali = row.tglKembali ? moment(row.tglKembali).format("YYYY-MM-DD") : undefined;
            if (this.adminAdv == true) {
              row.final = 1;
              row.send2wf = 1;
              row.iscomplete = 1;
              row.issuccess = 1;
              row.isreject = 0;
            }
            let lineno = 1;
            let newAdvLines;
            let newItem;
            let nonPJ = 0;
            if (this.model.ibudghdkey) {
              /*  newAdvLines = this.budgetLines.items.reduce((newArr, item) => {
                if (item.terpilih == 1) {
                  newItem = {
                    seqNo: lineno,
                    advDtlKey: item.advDtlKey || "",
                    DimTableKey: item.DimTableKey || "",
                    pjxbudgkey: item.pjxbudgkey,
                    ibudgdtkey: item.ibudgdtkey,
                    ibudghdkey: item.ibudghdkey,
                    uraian: `${item.jccostname} ${item.uraian || ""}`,
                    kodeacc: item.kodeacc,
                    nilai: item.nilai || item.ibbudgetamt,
                    fixExpen: item.fixExpen || 0,
                  };
                  item.duedate = item.duedate
                    ? moment(item.duedate).format("YYYY-MM-DD")
                    : undefined;
                  this.dimension.forEach((dim) => {
                    if (item[dim.value]) {
                      newItem[dim.value] = item[dim.value];
                      newItem[`${dim.value}Txt`] = item[`${dim.value}Txt`];
                    }
                  });
                  newArr.push(newItem);
                  lineno += 1;
                }
                return newArr;
              }, []); */
              newAdvLines = this.advLines.items.reduce((newArr, item) => {
                if (item.uraian && item.nilai) {
                  item.seqNo = lineno;
                  item.pjxbudgkey = item.pjxbudgkey;
                  item.ibudgdtkey = item.ibudgdtkey;
                  item.ibudghdkey = item.ibudghdkey;
                  item.duedate = item.duedate ? moment(item.duedate).format("YYYY-MM-DD") : undefined;
                  newArr.push(item);
                  nonPJ += item.fixExpen == 1 ? item.nilai : 0;
                  lineno += 1;
                }
                return newArr;
              }, []);
            } else {
              newAdvLines = this.advLines.items.reduce((newArr, item) => {
                if (item.uraian && item.nilai) {
                  item.seqNo = lineno;
                  item.duedate = item.duedate ? moment(item.duedate).format("YYYY-MM-DD") : undefined;
                  newArr.push(item);
                  nonPJ += item.fixExpen == 1 ? item.nilai : 0;
                  lineno += 1;
                }
                return newArr;
              }, []);
            }
            if (newAdvLines.length == 0) {
              toastr.error("Please fill at least 1(one) line/Detail transaction", "ERROR MESSAGE", 10000);
              this.saveEnabled = true;
              this.isLoading = false;
              return;
            }

            row.lines = newAdvLines;
            row.nonPJ = nonPJ;
            // await advance.insert(row);
            // toastr.success("Complete successfully", "Save ADVANCE");
            // this.close();
            const hasil = await advance.insert(row);
            toastr.success(`Success, Trx.Number ${hasil.nomor}`, "Save ADVANCE", 10000);

            if (this.inputBerlanjut == 0) {
              this.close();
            } else {
              this.saveEnabled = true;
              const jenisAdv = this.model.jenisAdv;
              for (var key in this.model) {
                this.model[key] = "";
              }
              this.model.jenisAdv = jenisAdv;
              this.advLines.items = [];
              this.calcDtlAdv();
              this.$v.model.$reset();
            }
          } else {
            this.saveEnabled = true;
            console.log("dimValResult : ", dimValResult);
            var msg = dimValResult.message || "Dimension validation error";
            toastr.error(msg, "ERROR MESSAGE");
          }
        } catch (error) {
          console.log("error : ", error);
          if (error.sql) {
            toastr.error(error.sql, "ERROR MESSAGE", 10000);
          } else if (error.sqlMessage) {
            toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
          } else if (error.message) {
            toastr.error(error.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
          this.saveEnabled = true;
        }
      }
    },
    updateDimDtl2Hdr: function (dimDtl) {
      var dimHdr = this.model;
      this.dimension.forEach((dim) => {
        if (dimDtl[dim.value] && !dimHdr[dim.value]) {
          dimHdr[dim.value] = dimDtl[dim.value];
          dimHdr[`${dim.value}Txt`] = dimDtl[`${dim.value}Txt`];
          dimHdr[`${dim.value}Info`] = dimDtl[`${dim.value}Info`];
        }
      });
      this.updateDimHdr = !this.updateDimHdr;
    },
    updateDimHdr2Dtl: function (dimDtl) {
      var dimHdr = this.model;
      dimDtl = dimDtl || this.advLinesObj;
      this.dimension.forEach((dim) => {
        if (dimHdr[dim.value] && !dimDtl[dim.value]) {
          dimDtl[dim.value] = dimHdr[dim.value];
          dimDtl[`${dim.value}Txt`] = dimHdr[`${dim.value}Txt`];
          dimDtl[`${dim.value}Info`] = dimHdr[`${dim.value}Info`];
        }
      });
      this.updateDimDtl = !this.updateDimDtl;
    },
    checkedTogle(data) {
      if (this.$refs.tblBudgetLines) this.$refs.tblBudgetLines.refresh();

      setTimeout(() => {
        this.calcDtlAdv();
      }, 1000);
    },
    checkBudgetamt(data) {
      // toastr.info(`Cash Advance Amount change to ${data.nilai.toLocaleString(undefined, { maximumFractionDigits: 2 })} `);
      let ttlBudgetItemReq = this.advLines.items
        .filter((x) => x.ibudgdtkey == data.ibudgdtkey && x.terpilih == 0)
        .reduce((amt = 0, data, indx) => {
          return (amt += data.nilai);
        }, 0);

      if (ttlBudgetItemReq + data.nilai > data.ibbudgetamt) {
        toastr.error(`Cash Advance Amount melebihi Budget Amount`);
        data.nilai = data.ibbudgetamt - ttlBudgetItemReq;
        return;
      }
      // this.calcDtlAdv();
    },
    calcDtlAdv: function () {
      let ttlnetto = 0;
      if (this.model.ibudghdkey) {
        console.log("budgeted : ");
        // this.budgetLines.items.forEach(function (item) {
        //   if (item.terpilih == 1) {
        //     // ttlnetto += item.ibbudgetamt || 0;
        //     ttlnetto += item.nilai || (item.ibbudgetamt || 0);
        //   }
        // });
        this.advLines.items.forEach(function (item) {
          if (item.uraian && item.nilai) {
            ttlnetto += item.nilai || 0;
          }
        });
        this.budgetbalance = ttlnetto; // hanya untuk agar kompatible dg versi code sebelumnya
      } else {
        this.advLines.items.forEach(function (item) {
          if (item.uraian && item.nilai) {
            ttlnetto += item.nilai || 0;
          }
        });
      }

      console.log("ttlnetto : ", ttlnetto);

      this.model.ttlnetto = ttlnetto;
    },
    close() {
      if (this.adminAdv == true) {
        router.push({ name: "advance.requestlist" });
      } else {
        router.push({ name: "advance.myrequest" });
      }
    },
  },
};
</script>
